function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 1.5H10",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 2.5V1.5",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 7.5V10.5",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 16.5C10.3137 16.5 13 13.8137 13 10.5C13 7.18629 10.3137 4.5 7 4.5C3.68629 4.5 1 7.18629 1 10.5C1 13.8137 3.68629 16.5 7 16.5Z",
  stroke: "#767B87",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgTimer = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer.7004459e.svg";
export { ForwardRef as ReactComponent };